var render = function render(){var _vm=this,_c=_vm._self._c;return _c('font-awesome-icon',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",value:({
    variant: 'danger',
    title: 'Delete',
    placement: _vm.position
  }),expression:"{\n    variant: 'danger',\n    title: 'Delete',\n    placement: position\n  }",modifiers:{"hover":true}}],staticClass:"icon-button",attrs:{"icon":['far', 'trash-alt']}})
}
var staticRenderFns = []

export { render, staticRenderFns }